import Header from '../../components/header/index.js';
import { useParams } from 'react-router-dom';

const episodiosData = {
    '1': {
        video: 'Bernardo Cabral',
        link: 'https://www.youtube.com/embed/LvnqjJTr2Is',
        intertitulo: 'Cicatriz orgulhosa do dever cumprido',
        texto: 'Relator geral da Assembleia Nacional Constituinte de 1987/88, Bernardo Cabral (1932) narra sua trajetória de presidente da Ordem dos Advogados do Brasil (OAB) a deputado federal, senador e ministro da Justiça do governo Fernando Collor. O parlamentar conta como teve o mandato cassado pelo AI-5, em 1968, e mostra as ações do regime militar para promover "a desmoralização do Legislativo e o enfraquecimento do Judiciário". Mostra ainda os embates da luta pela instalação da Constituinte – ao lado de Ulysses Guimarães e Mário Covas, entre outros –, relata as ameaças ao processo democrático e comemora a vitória que levou o país "da excepcionalidade institucional ao reordenamento constitucional".',
    },
    '2': {
        video: 'Jarbas Passarinho',
        link: 'https://www.youtube.com/embed/SPbiqciRLnQ',
        intertitulo: 'Três nomes, várias facetas',
        texto: 'Em depoimento inédito, Jarbas Passarinho (1920-2016) revela detalhes dos bastidores da disputa por poder durante a ditadura militar, das manobras internas às decisões que levaram aos Atos Institucionais. Narra também a própria carreira política: após o golpe de 1964, foi governador do estado do Pará, ministro de três governos militares e senador da República por três mandatos. Uma das principais lideranças da transição democrática, o parlamentar conta como participou ativamente da Assembleia Nacional Constituinte de 1987/88, em comissões temáticas e nos intrincados corredores do diálogo político.',
    },
    '3': {
        video: 'Marco Maciel',
        link: 'https://www.youtube.com/embed/l-2YTzmQi44',
        intertitulo: 'Incansável articulador de diferenças',
        texto: 'Um dos artífices do processo de Abertura, Marco Maciel (1940-2021) teve três mandatos de senador, foi ministro e chegou à vice-presidência da República no governo Fernando Henrique Cardoso. O parlamentar comenta sua trajetória política, do período na Arena, partido da base da ditadura militar, quando chegou à Presidência da Câmara, até a transição dos anos 1980 e a formação do PFL. No depoimento, Maciel analisa decisões do poder, tanto no "Estado autoritário" como nos primeiros anos da retomada democrática.',
    },
    '4': {
        video: 'José Genoíno',
        link: 'https://www.youtube.com/embed/580pQntTbKM',
        intertitulo: 'Entre a ruptura e a conciliação',
        texto: 'A partir de sua trajetória política, da luta armada e a Guerrilha do Araguaia até a prisão e a eleição como deputado federal, José Genoíno (1946) analisa as tensões permanentes no processo constituinte de 1987/88. Liderança importante do Partido dos Trabalhadores que participou da elaboração do regimento interno, o parlamentar mostra dois lados envolvidos nas discussões do texto constitucional: os adeptos de mudança mais radical e os que buscavam democratização pactuada entre diversos setores da sociedade brasileira.',
    },
    '5': {
        video: 'O Golpe de 1964 e o Parlamento',
        link: 'https://www.youtube.com/embed/tH_7e17_qNA',
        intertitulo: 'A cassação da liberdade',
        texto: 'Apesar de contar com a adesão da maioria do Congresso Nacional, o golpe de 1964 estabeleceu intervenção rigorosa da ditadura militar na vida parlamentar, atingindo sobretudo o MDB, partido de oposição. O episódio apresenta números e aborda as intervenções mais diretas – as cassações de mandatos e os fechamentos do Congresso –, além das repercussões na sociedade brasileira.',
    },
    '6': {
        video: 'A Redemocratização',
        link: 'https://www.youtube.com/embed/E0cjqGJItvU',
        intertitulo: 'As vias dos fatos na distensão',
        texto: 'A volta do Estado Democrático de direito é observada de um ponto de vista privilegiado por representantes de distintas correntes políticas, figuras de destaque do Legislativo da época. Os parlamentares fazem relatos pessoais e destacam também a participação de instituições na transição, como a Conferência Nacional dos Bispos do Brasil (CNBB), a Associação Brasileira de Imprensa (ABI) e a Ordem dos Advogados do Brasil (OAB).',
    },
    '7': {
        video: 'A Constituição de 1988',
        link: 'https://www.youtube.com/embed/yFLiuMDspGc',
        intertitulo: 'A guerra ou o debate',
        texto: 'Fecho do processo de transição democrática no Brasil, a Constituição de 1988 definiu o fundamento do Estado Democrático de direito depois de 21 anos de ditadura militar. Os bastidores da Assembleia Nacional Constituinte de 1987/1988 são narrados por três parlamentares protagonistas do processo.',
    },
    '8': {
        video: 'Yanomami',
        link: 'https://www.youtube.com/embed/8iJWqmZSlWY',
        intertitulo: 'Não queremos morrer outra vez',
        texto: 'A partir do canto e da dança, em manifestações culturais retumbantes na Esplanada dos Ministérios, o episódio demarca temas caros aos povos indígenas. Rememora as conquistas constitucionais de 1988, com destaque para a atuação de Ailton Krenak e seu antológico discurso na Assembleia Constituinte, e exibe a atual crise humanitária do povo Yanomami.',
    },
    '9': {
        video: '8 de janeiro',
        link: 'https://www.youtube.com/embed/Y7KLlWmHUFk',
        intertitulo: 'Atentado à democracia brasileira',
        texto: 'O episódio conta a história do fatídico 8 de Janeiro da perspectiva do Poder Legislativo. Imagens da destruição no Congresso Nacional, no Supremo Tribunal Federal e no Palácio do Planalto dão a dimensão do crime cometido em uma manifestação aterrorizante contra a democracia e a sociedade brasileira.',
    },
};

export default function Episodios() {
    const { ep } = useParams();
    const data = episodiosData[ep] || episodiosData['1'];
    const { video, link, intertitulo, texto } = data;

    return (
        <div>
            <Header show={false} cor='preto' />

            <div
                className="w-full h-screen bg-cover bg-center"
                style={{ backgroundImage: `url(${require('../../assets/episodios.png')})` }}
            >
                <div className="w-full h-full grid grid-cols-1 md:grid-cols-[15vw_1fr] gap-4 md:gap-20 px-[5vw] md:px-[100px] pt-[80px] md:pt-[150px] pb-[5vh] md:pb-[100px] bg-white/80">

                    {/* ── ESQUERDA ── */}
                    <div className="flex flex-col justify-between gap-2 md:gap-0">
                        {/* Intertítulo + Texto */}
                        <div className="flex flex-col items-start text-start text-[#3a3232] font-['Lato'] space-y-1">
                            <p className="text-black text-xs md:text-base font-bold leading-tight pb-2 md:pb-4">
                                {intertitulo}
                            </p>
                            <p className="text-xs md:text-sm text-[#3a3232] leading-relaxed">
                                {texto}
                            </p>
                        </div>

                        {/* Número do episódio */}
                        <div className="flex items-start gap-2 font-['Lato'] text-black mt-4 md:mt-0">
                            <div className="flex flex-col leading-none">
                                <span className="text-xs md:text-[20px]">EPISÓDIO</span>
                                <span className="text-4xl md:text-[85px] font-bold leading-none mt-[-4px] md:mt-[-10px]">{ep}</span>
                            </div>
                            <span className="text-sm md:text-[26px] mt-1 md:mt-5">{video}</span>
                        </div>
                    </div>

                    {/* ── DIREITA — iframe ── */}
                    <div className="bg-black w-full h-[40vw] md:h-full min-h-[200px]">
                        <iframe
                            src={link}
                            title={video}
                            className="w-full h-full"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}